import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

function formatErr(d) {
  if (!d) return "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-deep flex items-center justify-center px-6 grain">
      <div className="w-full max-w-md relative z-10">
        <img src="/brand/wedo_logo_2024.png" alt="WeDo" className="h-20 invert brightness-0 contrast-200 mb-12 mx-auto"/>
        <div className="bg-paper p-10">
          <p className="section-num">Back-office</p>
          <h1 className="display text-3xl mt-3">Connexion administrateur</h1>
          <form onSubmit={onSubmit} className="mt-8 space-y-2" data-testid="admin-login-form">
            <input
              type="email" required placeholder="Email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="field" data-testid="admin-email"
            />
            <input
              type="password" required placeholder="Mot de passe"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="field" data-testid="admin-password"
            />
            {error && <p className="text-sm text-accent-pink pt-3" data-testid="admin-error">{error}</p>}
            <button type="submit" disabled={loading}
              className="btn-pill btn-primary w-full justify-center mt-8 disabled:opacity-60"
              data-testid="admin-submit"
            >
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
